import { Component } from "react";
import { triggerEvent, wvusLogger } from "../../helpers";
import { getPhrase, PhraseKey } from "../../languages";

// When passing in a value for children, also pass a matching value for message
// so analytics and logging match what the user sees.
type AppErrorPropsType = {
  error?: Error;
  message?: string;
  children?: JSX.Element;
};

const DEFAULT_PHRASE_KEY = "errors.general_error_volunteer";
const DEFAULT_ERROR_MESSAGE =
  "An error has occurred. Please try again, and if the problem persists, refresh the page or ask a volunteer for help.";

export default class AppError extends Component<AppErrorPropsType> {
  constructor(props: AppErrorPropsType) {
    super(props);
  }

  // Resolve the phrase key and user-facing copy
  getDisplay() {
    let phraseKey = DEFAULT_PHRASE_KEY;
    let errorMessage = DEFAULT_ERROR_MESSAGE;

    try {
      if (this.props?.message) {
        phraseKey = `${this.props?.message}:dynamic`;
        errorMessage = this.props?.message;
      } else {
        errorMessage = getPhrase(phraseKey as PhraseKey) || DEFAULT_ERROR_MESSAGE;
      }
    } catch {
      phraseKey = DEFAULT_PHRASE_KEY;
      errorMessage = DEFAULT_ERROR_MESSAGE;
    }

    return { phraseKey, errorMessage };
  }

  componentDidMount() {
    try {
      const { errorMessage } = this.getDisplay();
      const errorDetail = this.props?.error?.message || "Unknown error occurred";

      wvusLogger.log(errorDetail, wvusLogger.getLogLevelNames().CRITICAL);
      console.log({ error: errorDetail });

      triggerEvent("error_view", {
        error_message: errorMessage,
        error_type: "app_error",
        event_label: errorDetail
      });
    } catch (e) {
      console.log(e);
    }
  }

  render() {
    const { phraseKey, errorMessage } = this.getDisplay();

    const messageElement = this.props?.children || (
      <p>
        <i className="fa fa-times-circle" aria-hidden="true"></i>{" "}
        <span data-phrase-key={phraseKey}>{errorMessage}</span>
      </p>
    );

    // TODO: Include Error Message HTML and Styles
    return (
      <div className="App AppError" style={{ maxWidth: "1200px", margin: "0 auto" }}>
        <div className="alert alert-danger" role="alert">
          <span className="glyphicon glyphicon-warning-sign" aria-hidden="true"></span>{" "}
          {messageElement}
        </div>
      </div>
    );
  }
}
